'use strict';

var ChartExampleDirective = function ChartExampleDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-example.html'),
    controller: 'ChartExampleController',
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement);
      scope.renderChartDataPresent = function renderChart(data, selectionSize) {
        chart.withMetric(scope.selectedMetric).render(data);
        viewport.render(data, selectionSize);
      };
      scope.setInitialSelection = function (range) {
        chart.setInitialSelection(range);
      };
      chart.on('rangechange', function (ranges) {
        viewport.onMainChartBrushChange(ranges);
      });
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
      scope.initChart();
    }
  };
};
ChartExampleDirective.$inject = ['ChartExample', 'ChartExampleViewport'];
module.exports = ChartExampleDirective;